<template>
<div class="cities">
  <page-header title="Cities" class="page-banner">
    <template #secondary>
      <div class="title mb-3">
        <h2>
          <svg xmlns="http://www.w3.org/2000/svg" width="12.868" height="15.533" viewBox="0 0 12.868 15.533">
            <g transform="translate(-5.885 -1.104)">
              <path class="a" d="M6.434,15.533h0L1.884,10.984a6.435,6.435,0,0,1,9.1-9.1,6.434,6.434,0,0,1,0,9.1L6.435,15.533Zm0-12.153A2.987,2.987,0,1,0,9.421,6.369,2.991,2.991,0,0,0,6.433,3.381Z" transform="translate(5.885 1.104)" />
            </g>
          </svg>
          {{ cityCount | formatNumber }}&nbsp;Cities
        </h2>
        <h2><i class="icons8-user-account"></i>{{ memberCount | formatNumber }}&nbsp;{{ 'Member' | pluralize(memberCount) }}</h2>
      </div>
    </template>
  </page-header>
  <content-loader v-if="$apollo.loading" title="Cities" />
  <div v-else>
    <div class="map-container">
      <div class="container">
        <google-map class="city-map" :markers="markers" :zoom="parseFloat(2)" dark-theme></google-map>
      </div>
    </div>
    <div class="container city-listing">
      <div v-for="subcontinent in displaySubcontinents" :key="subcontinent.id">
        <subcontinent-card v-if="subcontinent.countries.length" :subcontinent="subcontinent"></subcontinent-card>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import {
  ListCountries,
  Cities,
  Members
} from "@/newgql/ListCountries.gql";
import {
  ListSubcontinents
} from "@/newgql/ListSubcontinents.gql";
import SearchBar from "@/components/global/SearchBar";
import GoogleMap from "@/components/global/GoogleMap";
import PageHeader from '@/components/global/PageHeader';
import ContentLoader from '@/components/global/ContentLoader';
import SubcontinentCard from '@/components/cities/SubcontinentCard';

export default {
  components: {
    SearchBar,
    GoogleMap,
    PageHeader,
    ContentLoader,
    SubcontinentCard
  },

  apollo: {
    subcontinents: ListSubcontinents,
    countries: ListCountries,
    cities: Cities,
    members: Members
  },

  data() {
    return {
      subcontinents: '',
      countries: '',
      cities: '',
      members: ''
    }
  },

  computed: {
    markers() {
      return this.countries.map((country) => {
        return {
          name: country.name,
          longitude: country.longitude,
          latitude: country.latitude,
          membercount: country.cities.reduce((totalMembers, city) => {
            return totalMembers + city.members.aggregate.count;
          }, 0)
        }
      }).filter(country => country.membercount > 0).sort((a, b) => b.membercount - a.membercount);
    },

    cityCount() {
      return this.cities && this.cities.aggregate.count;
    },

    memberCount() {
      return this.members && this.members.aggregate.count;
    },

    displaySubcontinents() {
      return this.subcontinents && this.subcontinents.map(subcontinent => {
        let total = 0;
        subcontinent.countries.forEach(country => {
          country.cities.forEach(city => {
            total = total + city.members.aggregate.count
          });
        });

        return {
          memberCount: total,
          ...subcontinent,
        }
      }).sort((a, b) => {
        return b.memberCount - a.memberCount;
      });
    }
  },
}
</script>
<style lang="scss" scoped>
.cities {
    .title {
        color: $light-grey;

        svg {
            width: 20px;
            height: 22px;
            margin-right: 8px;
            margin-bottom: 6px;
            path {
                fill: $light-grey;
            }
        }
        i {
            vertical-align: middle;
            font-size: 29px;
            margin-right: 12px;
            color: $light-grey;
        }

        h2 {
            font-weight: 300;
        }
    }
    .jumbotron {
        margin-bottom: 0;
    }

    .city-listing {
        margin-bottom: 100px;
    }

}
.map-container {
    background-color: $secondary;
    margin-bottom: 70px;
    min-height: 350px;
    @include media-breakpoint-up(md) {
        padding: 20px 0 0;
    }
}

.city-map /deep/ .map {
    width: 100%;
    margin: 0 auto;
    height: 350px;
    @include media-breakpoint-up(md) {
        height: 405px;
    }
    @include media-breakpoint-up(lg) {
        height: 650px;
        max-width: 1090px;
    }
}
</style>
